import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=01b0a80a&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=01b0a80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b0a80a",
  null
  
)

export default component.exports